import { render } from "./Widerrufsbelehrung.vue?vue&type=template&id=6f2e29ee"
import script from "./Widerrufsbelehrung.vue?vue&type=script&lang=js"
export * from "./Widerrufsbelehrung.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__